export default __webpack_public_path__ + "static/media/bannerpromo-HS-MS_intermx_330x330.b4bd3d98.webp";